import { IconDownload } from "@tabler/icons-react";
import { Button, Dialog, DialogContent, DialogHeader, DialogTitle, Group, Loader, Text, ThemeIcon } from "@/components/ui";
import { extensionDe, nodoIconoPorExtension } from "../utils/documento-helpers";
import { DocumentoPreviewContent, type DocumentoPreview } from "./DocumentoPreviewContent";

/**
 * Modal envolvente para la previsualización · header con icono + nombre,
 * body con el viewer (delegado a `DocumentoPreviewContent`), footer con
 * acciones (descargar / cerrar).
 *
 * Si `preview` es null (todavía cargando), muestra un loader; si está
 * presente, delega al content. Esto evita que el modal se vea vacío
 * mientras el blob fetch está en vuelo.
 */
export function DocumentoPreviewModal({
  opened,
  preview,
  nombre,
  descargando,
  onCerrar,
  onDescargar,
}: {
  opened: boolean;
  preview: DocumentoPreview | null;
  nombre: string;
  descargando: boolean;
  onCerrar: () => void;
  onDescargar: () => void;
}) {
  const ext = extensionDe(nombre);
  return (
    <Dialog open={opened} onOpenChange={(next) => !next && onCerrar()}>
      <DialogContent className="flex max-w-4xl flex-col p-0">
        <DialogHeader className="mb-0 px-5 pt-5">
          <DialogTitle>
            <Group gap="sm" wrap="nowrap">
              <ThemeIcon variant="filled" color="multiva" size="md">
                {nodoIconoPorExtension(ext, 14, 1.7)}
              </ThemeIcon>
              <Text fw={600} truncate span>
                {nombre}
              </Text>
            </Group>
          </DialogTitle>
        </DialogHeader>
        <div className="mt-4 border-t border-border bg-background" style={{ height: "70vh" }}>
          {preview ? (
            <DocumentoPreviewContent preview={preview} nombre={nombre} />
          ) : (
            <div className="flex h-full items-center justify-center">
              <Loader size="sm" />
            </div>
          )}
        </div>
        <Group justify="flex-end" gap="xs" className="p-3">
          <Button variant="default" leftSection={<IconDownload size={14} />} loading={descargando} onClick={onDescargar}>
            Descargar
          </Button>
          <Button variant="subtle" onClick={onCerrar}>
            Cerrar
          </Button>
        </Group>
      </DialogContent>
    </Dialog>
  );
}
